// extracted by mini-css-extract-plugin
module.exports = {"orderSummary":"OrderSummary-module__orderSummary___2W577","loading":"OrderSummary-module__loading___WsCYZ"};